import { render, staticRenderFns } from "./DuelTipEditor.vue?vue&type=template&id=517c1413&"
import script from "./DuelTipEditor.vue?vue&type=script&lang=js&"
export * from "./DuelTipEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports